'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './webaccess-edit.routes';

export class WebaccessEditComponent {
  constructor(Auth, $state, $stateParams, dialogs, WebAccessService, SettingsService, $uibModal, User, ContactService,
              CustomEntityService, CommunityService, prompt) {
    'ngInject';

    this.webaccessId = $stateParams.id;

    this.dialogs = dialogs;
    this.WebAccessService = WebAccessService;
    this.SettingsService = SettingsService;
    this.$uibModal = $uibModal;
    this.User = User;
    this.Auth = Auth;
    this.prompt = prompt;

    this.jsonValue = "";
    this.users = [];
    this.$state = $state;

    this.selectedSubs = {};

    this.activationType = "invitation";
    this.activationTypes = [{
      type: "initial",
      name: "Initial Password"
    }, {
      type: "invitation",
      name: "Invitation"
    }];

    ContactService.query(data => {
      this.contacts = data.map(contact => {
        contact.value = contact._id;
        contact.name = this.getComposedName(contact);
        return contact;
      });
    });
    this.customEntities = CustomEntityService.query();

    this.model = {
    };

    SettingsService.getByName({name: 'client'}, clientData => {
      this.eVotingEnabled = clientData.data.eVotingEnabled;
    });

    SettingsService.getByName({name: 'config.app'}, appSettings => {
      this.webAccessGroupConfig = appSettings.data.webAccessGroupConfig || [];

      CommunityService.query(data => {
        let websites = [];
        let evotingSites = [];

        this.subAssociationMap = {};

        this.webAccessGroupConfig.forEach(grp => {
          this.subAssociationMap[grp.code] = [];
          websites.push({
            type: 'Association Group Sites',
            code: grp.code,
            name: grp.name + ' (' + grp.website + ')'
          });
        });

        this.communities = data;
        data.forEach(site => {
          if (!site.eVoting || !site.eVoting.enabled)
            return;

          evotingSites.push({
            code: site.code,
            name: site.name + ' (' + site.eVoting.url + ')'
          });

          this.evotingSites = evotingSites;
        });
        data.forEach(site => {

          if (!site.webAccess.enabled)
            return;

          if (site.webAccess.accessGroupCode) {
            this.subAssociationMap[site.webAccess.accessGroupCode].push({code: site.code, name: site.name});
          } else {
            websites.push({
              type: 'Individual Sites',
              code: site.code,
              name: site.name + ' (' + site.webAccess.website + ')'
            })
          }
        });

        this.websites = websites;
      })
    });

    if (this.webaccessId) {
      this.WebAccessService.get({id: this.webaccessId}, data => {
        this.model = data;

        if (this.model.associations) {
          this.model.associations.forEach(code => {
            this.selectedSubs[code] = true;
          });
        }
      }, err => {
        console.log('Could not load webaccess from server');
      })
    }

  }

  getComposedName(contact) {
    let composedName = "";

    if (contact.lastName && contact.firstName) {
      composedName = contact.lastName + ", " + contact.firstName;
      if (contact.middleName)
        composedName += " " + contact.middleName;
    }

    if (contact.company) {
      if (composedName == "")
        composedName += contact.company;
      else
        composedName += " (" + contact.company + ")";
    }

    return composedName || "-";
  }

  updateEmail() {
    if (this.model.contact) {
      let oContact = this.contacts.find(o => o._id == this.model.contact);

      if (oContact) {
        let primaryEmail = this.getPrimaryEmail(oContact);
        if (primaryEmail !== '-') {

          if (!this.model.email || (this.model.email == primaryEmail)) {
            this.model.email = primaryEmail;
          } else {

            this.prompt({
              "title": "Replace Email?",
              "message": "The selected contact has another primary email as the one that is currently defined. Do you want to replace the current email?",
              "buttons": [
                {
                  "label": "Cancel",
                  "cancel": true,
                  "primary": false
                },
                {
                  "label": "Yes",
                  "cancel": false,
                  "primary": true
                }
              ]
            }).then(result => {
              this.model.email = primaryEmail;
            });

          }

        }
      }
    }


  }

  populateActivationType() {
    if (!this.webaccessId) {
      let group = this.webAccessGroupConfig.find(gc => gc.code == this.model.associationOrGroupCode);
      if (group) {
        this.model.activationType = group.activationType || 'invitation';
        this.model.password = group.defaultPassword;
      } else {
        let cmty = this.communities.find(cmty => cmty.code == this.model.associationOrGroupCode);
        if (cmty) {
          this.model.activationType = cmty.webAccess.activationType || 'invitation';
          this.model.password = cmty.webAccess.defaultPassword;
        }
      }
    }
  }

  getPrimaryEmail(contact) {
    if (!contact || !contact.email || !contact.email.length)
      return "-";

    let email = contact.email.find(email => email.isPrimary) || contact.email[0] || {address:'-'};

    return email.address;
  }

  getRolesByCode(code) {
    let selected = this.webAccessGroupConfig.find(gc => gc.code == code);
    if (selected) {
      return selected.roles;
    }
  }

  contactLookup() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'contactLookup',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (contact) {
        that.model.contact = contact._id;
        that.updateEmail();
      },
      function () { /* cancel */ }
    );

  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    if (!this.model.associationOrGroupCode && !this.model.eVotingCode) {
      alert('You must choose a website or an e-voting app to grant access to');
      return;
    }

    /* Set webaccess if selected */
    if (this.model.associationOrGroupCode) {
      let subs = [];

      if (this.subAssociationMap[this.model.associationOrGroupCode]) {
        subs = this.subAssociationMap[this.model.associationOrGroupCode].filter(sub => this.selectedSubs[sub.code]).map(sub => sub.code);
      }

      this.model.associations = subs;
    } else {
      this.model.associations = [];
    }

    /* Set e-voting role */
    if (this.model.eVotingCode) {
      if (!this.model.additionalRoles)
        this.model.additionalRoles = [];

      if (this.model.additionalRoles.indexOf("evoting-user") === -1)
        this.model.additionalRoles.push("evoting-user");
    } else {
      if (this.model.additionalRoles && Array.isArray(this.model.additionalRoles) && this.model.additionalRoles.indexOf("evoting-user") !== -1) {
        this.model.additionalRoles = this.model.additionalRoles.filter(role => role !== "evoting-user");
      }
    }

    if (form.$valid) {

      var onSuccess = () => {
        var actionString = (this.webaccessId) ? "changed" : "created";
        var dlg = this.dialogs.notify("Success", "The web acccess has been "+actionString+" successfully");
        dlg.result.then(() => {
          that.$state.go("webaccess-list");
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      this.model.email = this.model.email.trim().toLowerCase();

      if (this.webaccessId) {  // Save changes on the current webaccess
        this.WebAccessService.update({id: this.webaccessId  }, this.model, onSuccess, onError);
      } else { // Create new webaccess
        this.model.meta = {creationUser: this.Auth.getCurrentUserSync()._id};
        this.WebAccessService.save(this.model, onSuccess, onError);
      }
    }
  }
}

export default angular.module('conduu.webaccessEdit', [uiRouter])
  .config(routes)
  .component('webaccessEdit', {
    template: require('./webaccess-edit.html'),
    controller: WebaccessEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/webaccess/edit/webaccess-edit.component.js